import { isLargeMediumViewPort } from "../../ui/helpers/viewportHelper";
import { updateMultiFacet } from "../../store/actionCreators";
import applyFacets from "./apply";
import {
  analyticsSelectAll,
  analyticsAddPendingSelectAll
} from "../../../../analytics/actions";

const getFacetById = (state, facetId) => {
  const {
    search: { facets }
  } = state;

  return facets.find(facet => facet.id === facetId);
};

const getSelectedFacetValues = ({ facetValues }, facetId) =>
  facetValues.reduce((acc, facetValue) => {
    if (!facetValue.count) {
      return acc;
    }

    acc.push({
      facetId,
      valueId: facetValue.id,
      isSelected: true
    });

    return acc;
  }, []);

export default function selectAll(facetId) {
  return (dispatch, getState) => {
    const state = getState();
    const facet = getFacetById(state, facetId);

    if (facet) {
      dispatch(updateMultiFacet(getSelectedFacetValues(facet, facetId)));

      if (isLargeMediumViewPort(state)) {
        dispatch(applyFacets({ keepSelections: true }));
        dispatch(analyticsAddPendingSelectAll(facet));
      } else {
        dispatch(analyticsSelectAll(facet));
      }
    }
  };
}
